/**
 * Trims all whitespace from a string, including internal spaces.
 * Handles null/undefined values and non-string inputs gracefully.
 * 
 * @param input - The input value to trim
 * @returns Trimmed string or the original value if it's not a string
 */
export const trimSpaces = (input: unknown): string => {
  // Return empty string for null/undefined
  if (input === null || input === undefined) {
    return '';
  }

  // Convert to string if input is not already a string
  const str = typeof input === 'string' ? input : String(input);
  
  // Remove all whitespace characters (spaces, tabs, newlines, etc.)
  return str.replace(/\s+/g, '');
};

/**
 * Trims only leading and trailing whitespace from a string.
 * 
 * @param input - The input value to trim
 * @returns String with leading/trailing whitespace removed, or the original value if it's not a string
 */
export const trimEdges = (input: unknown): string => {
  if (input === null || input === undefined) {
    return '';
  }
  
  const str = typeof input === 'string' ? input : String(input);
  return str.trim();
};
